export default __webpack_public_path__ + "static/media/burger-menu-icon.a3253a76.svg";